import React, { useState } from 'react';
import './../../entrydoor.css';

const TransomCasing = ({ value, onChange, label = 'Transom Casing', childs = [] }) => {
    const [selectedTransomCasing, setSelectedTransomCasing] = useState(value || "None");

    const visibleShapes = ["MDF", "FJPine", "Poplar", "RedOak"];

    const handleTransomCasingChange = (e) => {
        const newValue = e.target.value;
        setSelectedTransomCasing(newValue); // Update local state
        onChange(newValue); // Call onChange prop with the new value

        // Dynamically fetch and modify styles for dependent controls if any exist
        if (Array.isArray(childs) && childs.length > 0) {
            childs.forEach((childId) => {
                const element = document.getElementById(childId);
                if (element) {
                    element.style.display = visibleShapes.includes(newValue) ? "block" : "none";
                    const label = element.previousElementSibling; // Fetch the label, if present
                    if (label) {
                        label.style.display = visibleShapes.includes(newValue) ? "block" : "none";
                    }
                }
            });
        }

    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} htmlFor="TransomCasing">{label}</label>
            <select style={{ display: "none" }}
                id="TransomCasing"
                value={selectedTransomCasing}
                onChange={handleTransomCasingChange}
            >
              <option value="" disabled hidden>Select an option</option>  
              <option value="None">{selectedTransomCasing === "None" ? "None ✔" : "None"}</option>
              <option value="MDF">{selectedTransomCasing === "MDF" ? "MDF ✔" : "MDF"}</option>
              <option value="FJPine">{selectedTransomCasing === "FJPine" ? "FJ Pine ✔" : "FJPine"}</option>
              <option value="Poplar">{selectedTransomCasing === "Poplar" ? "Poplar ✔" : "Poplar"}</option>
              <option value="RedOak">{selectedTransomCasing === "RedOak" ? "Red Oak ✔" : "RedOak"}</option>
            </select>
        </div>
    );
};

export default TransomCasing;
